export enum PregnancyDeliveryType {
    VAGINAL = 'Vaginal',
    C_SECTION = 'C-Section',
}
